
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/places/[id]/[slug]",
      function () {
        return require("private-next-pages/places/[id]/[slug].tsx");
      }
    ]);
  